import { render, staticRenderFns } from "./AppBrowser.vue?vue&type=template&id=098a6b2a&scoped=true"
import script from "./AppBrowser.vue?vue&type=script&lang=js"
export * from "./AppBrowser.vue?vue&type=script&lang=js"
import style0 from "./AppBrowser.vue?vue&type=style&index=0&id=098a6b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098a6b2a",
  null
  
)

export default component.exports